import LegacySignInForm from './LegacySignInForm'

export { LegacySignInForm }
export default LegacySignInForm
